export default __webpack_public_path__ + "static/media/gallery11.e30716f0.jpeg";